import React from 'react';
import { colours } from 'utils/constants';

interface Props {
  buttonLabel: string;
  onClick?: () => void;
  variant?: string; // default, primary, info, success, warning, danger, dark
  size?: string; // New prop for more flexible sizing
  disabled?: boolean;
  position?: string;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  type?: 'reset' | 'button' | 'submit';
  buttonStyle?: string; // New prop to allow custom styles
}

const PrimaryButton: React.FC<Props> = ({
  buttonLabel,
  onClick,
  variant = 'default',
  size = 'md',
  disabled,
  position = '',
  iconLeft,
  iconRight,
  type = 'submit',
  buttonStyle = '', // Default empty string for custom styles
  ...rest
}) => {
  const disabledStyle = disabled
    ? {
        backgroundColor: colours.disabledButton,
        color: colours.disabledButtonText,
        cursor: 'not-allowed',
        opacity: 1
      }
    : {};

  return (
    <button
      type={type}
      className={
        `primary-btn ${variant} ${size} ${position} ${buttonStyle} flex items-center justify-center` +
        (disabled ? ' disabled' : '')
      }
      onClick={onClick}
      disabled={disabled}
      style={disabledStyle}
      {...rest}
    >
      {iconLeft} {buttonLabel} {iconRight}
    </button>
  );
};

export default PrimaryButton;
